module.exports = __webpack_public_path__ + "img/bg_product_bianjie2@2x.b0f6d257.png";